if (!customElements.get('collection-load-previous')) {
  class CollectionLoadPrevious extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('.js-btn-load-previous');
      this.productGrid = document.querySelector('#product-grid');
      this.loading = false;

      if (this.button) {
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.loadPrevious();
        });
      }

      this.hideOnFirstPage();
    }

    hideOnFirstPage() {
      const page = new URLSearchParams(window.location.search).get('page') || '1';
      if (page === '1') this.style.display = 'none';
    }

    async loadPrevious() {
      if (!this.button || !this.productGrid || this.loading) return;

      const url = this.button.dataset.href;
      if (!url) return;

      this.loading = true;
      this.button.setAttribute('disabled', 'true');
      this.button.classList.add('loading');

      try {
        const response = await fetch(url);
        const text = await response.text();
        const doc = new DOMParser().parseFromString(text, 'text/html');

        const container = doc.querySelector('#ProductGridContainer');
        const prevGrid = container && container.querySelector('#product-grid');

        if (prevGrid) {
          // Prepend the previous page's products above the current ones.
          this.productGrid.insertAdjacentHTML('afterbegin', prevGrid.innerHTML);
        }

        // Point the loader at the page before the one we just loaded.
        const prevLoadPrevious = container && container.querySelector('.js-btn-load-previous');
        if (prevLoadPrevious) {
          this.button.dataset.href = prevLoadPrevious.dataset.href;
        }

        // Decrement the ?page= value in the URL.
        const current = new URL(window.location.href);
        const params = current.searchParams;
        const currentPage = parseInt(params.get('page'), 10) || 1;
        params.set('page', Math.max(1, currentPage - 1));
        current.search = params.toString();
        history.replaceState({}, '', current.toString());

        this.hideOnFirstPage();
      } catch (error) {
        console.error('[collection-load-previous]', error);
      } finally {
        this.loading = false;
        this.button.removeAttribute('disabled');
        this.button.classList.remove('loading');
      }
    }
  }

  customElements.define('collection-load-previous', CollectionLoadPrevious);
}
